import { styled } from '@mui/material/styles';

const StyledProjectDetail = styled('div')`
  overflow: auto !important;
  position: relative;
  float: right;
  height: 100%;
  flex: 1;
  display: contents;
  .container-main-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export { StyledProjectDetail };
